import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import { toast } from 'react-toastify';

const TeamLeadRemainders = () => {
  const [remainders, setRemainders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 6;

  const headers = {
    Authorization: "Bearer sandeep_university_916",
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const fetchRemainders = async () => {
      const encodedEmployeeId = sessionStorage.getItem('H7Z4L9VD2XK5JW8QRYT6');
      if (!encodedEmployeeId) {
        toast.error('Employee ID not found. Please log in again.');
        return;
      }

      const teamLeadEmpId = atob(encodedEmployeeId);
      try {
        const response = await fetch(SummaryApi.TlRemainders.url, {
          method: "POST",
          headers,
          body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
        });

        const data = await response.json();
        if (data.status) {
          setRemainders(data.data);
        } else {
          setError("No remainders found.");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch remainders.");
      } finally {
        setLoading(false);
      }
    };

    fetchRemainders();
  }, []);

  // Pagination
  const totalPages = Math.ceil(remainders.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = remainders.slice(startIndex, startIndex + itemsPerPage);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Loading
  if (loading)
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-white text-2xl font-semibold animate-pulse">
        Loading Remainders...
      </div>
    );

  // Error
  if (error)
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-red-400 to-red-600 text-white text-xl font-semibold">
        {error}
      </div>
    );

  return (
    <div className="min-h-screen  py-12 px-6">
      <h2 className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-pink-600 mb-10">
         Team Lead Remainders
      </h2>

      {remainders.length === 0 ? (
        <p className="text-center text-gray-700 italic text-lg">
          No remainders available.
        </p>
      ) : (
        <>
          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentItems.map((item, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-lg rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300"
              >
                <div className="border-b border-gray-300 pb-3 mb-4">
                  <h3 className="text-xl font-bold text-indigo-700">
                    {item.student_name || "Unknown Student"}
                  </h3>
                </div>

                <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
                  <p>
                    <span className="font-semibold text-indigo-600">
                      Next Follow-up:
                    </span>{" "}
                    {item.next_followup_date_time
                      ? new Date(item.next_followup_date_time).toLocaleString()
                      : "Not scheduled"}
                  </p>
                  <p>
                    <span className="font-semibold text-indigo-600">
                      Description:
                    </span>{" "}
                    {item.lead_description || "(No description)"}
                  </p>
                  <p>
                    <span className="font-semibold text-indigo-600">
                      Mobile Number:
                    </span>{" "}
                    {item.mobile_number1 || "N/A"}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-12 space-x-4">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className={`px-5 py-2 rounded-full text-sm font-medium shadow-md transition-all duration-300 ${
                currentPage === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-gradient-to-r from-indigo-500 to-purple-500 text-white hover:opacity-90"
              }`}
            >
               Prev
            </button>

            <span className="text-gray-800 font-semibold">
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`px-5 py-2 rounded-full text-sm font-medium shadow-md transition-all duration-300 ${
                currentPage === totalPages
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:opacity-90"
              }`}
            >
              Next 
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default TeamLeadRemainders;
